export class AccessDeniedError extends Error {
  constructor(message = 'Du har ikke tilgang til denne kommunen.', status = 403) {
    super(message);
    this.name = 'AccessDeniedError';
    this.status = status;
  }
}

export function isAccessDeniedError(error) {
  return error instanceof AccessDeniedError;
}
